var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ssoLayout === 'innerLayout')?_c('div',{staticClass:"wits-eyes-inner-layout"},[_c('router-view')],1):_c('div',{staticClass:"wits-eyes-default-layout"},[_c('side-bar'),_c('div',{staticClass:"wits-eyes-main",class:_vm.collapse ? 'is-collapse-main' : ''},[_c('top-bar'),_c('app-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }